$(document).ready(function($) {
    var elementToShow = $('.bars.has-scroll-animation');
    var windowHeight = $(window).height();
    var offset = 50;
    elementToShow.each(function(){
        var $this = $(this);
        var top = $this.offset().top;
        var height = $this.outerHeight();
        var scroll = $(window).scrollTop();
        if (scroll + windowHeight > (top + height) - offset) {
            $this.addClass('animated');
        }
    });

    $(window).on('scroll', function(e){
        var scroll = $(window).scrollTop();
        var elementToShow = $('.bars.has-scroll-animation');
        var windowHeight = $(window).height();
        var offset = 50;
        elementToShow.each(function(){
            var $this = $(this);
            var top = $this.offset().top;
            var height = $this.outerHeight();
            if (scroll + windowHeight > (top + height) - offset) {
                $this.addClass('animated');
            }
        });
    });
});